import ComponentDescription from 'components/customs/ComponentDescription';
import ComponentHeader from 'components/cms/ComponentHeader';
import { QrCodeDefinitions } from './QrCodeDefinitions';

export class QrCode extends QrCodeDefinitions {

    render() {
        const { className, designing } = this.props;

        if (this.props.hideRuntime && !this.props.designing) return null;

        return (
            <div
                data-schema-id={this.props.id}
                className={["fa-Button disable-inside fa-draggable", designing && "designing", className].filter(e => !!e).join(" ")}>
                {designing && (
                    <ComponentHeader
                        componentEntry={this.props.entry}
                        componentSchemaId={this.props.id as string}
                    />
                )}
                <ComponentDescription
                    node={this.props.schemaNode}
                    entry={this.props.entry}
                />
            </div>
        )
    }
}
